import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_qr-dine-mgmt/artifacts/1p513flo_MenuMojo%20Logo.png";

export function Logo({ size = 40, withText = true, className = "", variant = "light" }) {
  const isDark = variant === "dark";
  return (
    <Link to="/" data-testid="brand-logo" className={`flex items-center gap-2 ${className}`}>
      <img src={LOGO_URL} alt="MenuMojo" style={{ width: size, height: size }} className="object-contain" />
      {withText && (
        <span className="font-heading font-extrabold text-xl tracking-tight">
          <span className={isDark ? "text-white" : "brand-navy"}>Menu</span>
          <span className="brand-orange">Mojo</span>
        </span>
      )}
    </Link>
  );
}

export { LOGO_URL };
